import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../../../../environments/environment';
import { Product } from './product.model';
import * as moment from 'moment';

@Injectable()
export class ProductService implements Resolve<any>
{
    routeParams: any;
    product: Product;
    onProductChanged: BehaviorSubject<any> = new BehaviorSubject({});
    onCategoriesChanged: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private http: HttpClient
    ) {}

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any
    {
        this.routeParams = route.params;
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getProduct()
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getProduct(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            if ( this.routeParams.id === 'new' )
            {
                this.onProductChanged.next(false);
                resolve(false);
            }
            else
            {
                this.http.get(environment.apiUrl + '/products/' + this.routeParams.id)
                    .subscribe((response: Product) => {
                        this.product = response;
                        this.onProductChanged.next(this.product);
                        resolve(response);
                    }, reject);
            }
        });
    }

    isDateValid(date: Date) {
        const year = (new Date()).getFullYear();
        const from = new Date(this.product.recurrenceStart);
        const to = new Date(this.product.recurrenceEnd);
        if (this.product.annualRecurrence) {
            from.setFullYear(year);
            to.setFullYear(year);
        }
        return moment(date).isBetween(from, to, null, '[]');
    }

    saveProduct(product)
    {
        return new Promise((resolve, reject) => {
            this.http.put(environment.apiUrl + '/products/' + product._id, product)
                .subscribe((response: any) => {
                    this.product = response;
                    this.onProductChanged.next(this.product);
                    resolve(response);
                }, reject);
        });
    }

    addProduct(product)
    {
        return new Promise((resolve, reject) => {
            this.http.post(environment.apiUrl + '/products/', product)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    postImageCarte(id: string, fileToUpload: File) {
        const endpoint = `${environment.apiUrl}/products/${id}/carte`;
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        return this.http
          .post(endpoint, formData);
    }
    deleteCarte(id: string) {
        const endpoint = `${environment.apiUrl}/products/${id}/carte`;
        return this.http
            .delete(endpoint);
    }

    closeAllSchedulesInAvailability(productId: string)
    {
        return new Promise((resolve, reject) => {
            this.http.post(environment.apiUrl + '/products/' + productId + '/schedules/closeAll', {})
                .subscribe((response: any) => {
                    this.product = response;
                    this.onProductChanged.next(this.product);
                    resolve(response);
                }, reject);
        });
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/product/product.service.ts